export default {
  paywall: {
    actions: {
      notNow: "Not now",
      noThanks: "No thanks",
      skip: "Skip",
    },
    generic: {
      title: "Unlock the full experience",
      subtitle: "Access everything you need to research, build, and place smarter bets",
      whyJoin: "Why join Linemate+?",
      comparePlans: "Compare plans",
      renewalDisclaimer: "Plan renews automatically. Cancel anytime.",
    },
    sources: {
      injuryImpact: {
        title: "Unlock Injury Impact",
        subtitle: "See how injuries impact teammates.\nGo deeper on every trend",
      },
      startingLineups: {
        title: "Unlock Starting Lineups",
        subtitle: "Find value when starting lineups change.\nGo deeper on every trend",
      },
      opponentRank: {
        title: "Unlock Opponent Defensive Rank",
        subtitle: "Exploit favourable defensive matchups.\nGo deeper on every trend",
      },
      weatherReport: {
        title: "Unlock Weather Report",
        subtitle: "Use wind and weather to your advantage.\nGo deeper on every trend",
      },
      startingPitchers: {
        title: "Unlock Starting Opponent Pitchers",
        subtitle: "Target spots against vulnerable pitchers.\nGo deeper on every trend",
      },
    },
    features: {
      injuryImpact: {
        title: "Injury Impact",
        description: "See how injuries impact teammates.",
      },
      startingLineups: {
        title: "Starting Lineups",
        description: "Find value when starting lineups change.",
      },
      opponentRank: {
        title: "Opponent Defensive Rank",
        description: "Exploit favourable defensive matchups.",
      },
      weatherReport: {
        title: "Weather Report",
        description: "Use wind and weather to your advantage.",
      },
      startingPitchers: {
        title: "Starting Opponent Pitchers",
        description: "Target spots against vulnerable pitchers.",
      },
    },
    comparison: {
      title: "Features",
      free: "Free",
      rows: {
        dailyTeamAndPlayerTrends: "Daily team & player trends",
        dailyParlayTrends: "Daily parlay trends",
        teamAndPlayerPropsTool: "Team & player props tool",
        statsAndStandings: "Stats & standings",
        dailyCheatsheets: "Daily cheatsheets",
        advancedSignalsAndTools: "Advanced signals & tools",
        startingLineups: "Starting Lineups",
        injuryImpact: "Injury Impact",
        opponentDefensiveRank: "Opponent Defensive Rank",
        weatherReports: "Weather Reports",
        startingOpponentPitchers: "Starting Opponent Pitchers",
      },
    },
    plans: {
      bestValue: "Best Value",
      annual: "Annual",
      monthly: "Monthly",
      yearlyPlan: "Yearly Plan",
      monthlyPlan: "Monthly Plan",
      perYearShort: "yr",
      perMonthShort: "mo",
    },
    onboarding: {
      trialTitle: "Start your 7-day free trial",
      trialSubtitle: "Choose a plan to continue after your trial ends",
    },
    cta: {
      claimYourCode: "Claim your code",
      startYourFreeTrial: "Start your free trial",
      startMy7DayFreeTrial: "Start my 7-day free trial",
      tryFreeAndSubscribe: "Try free and subscribe",
      upgradeToLinematePlus: "Upgrade to Linemate+",
    },
    trial: {
      sevenDaysFree: "7 days free",
      thenPerMonth: "{{trial}}, then {{price}} per month",
      thenPerYear: "{{trial}}, then {{price}} per year ({{monthlyPrice}}/{{perMonthShort}})",
      startingOn: " starting on {{date}}",
      standardPerMonth: "{{price}} per month",
      standardPerYear: "{{price}} per year ({{monthlyPrice}}/{{perMonthShort}})",
      subtitleSuffix: " with a 7-day free trial.",
    },
  },
};
